import { Box, Typography, Grid } from '@mui/material';
import { IRiskRegister } from '../../List';

interface DetailViewProps {
  riskDetail: IRiskRegister;
}

const DetailView: React.FC<DetailViewProps> = (props) => {
  const { riskDetail } = props;
  return (
    <>
      <Box className="app-card">
        <Box className="title">
          <Typography variant="h4">Risk Overview</Typography>
        </Box>
        <Box className="content">
          <Grid spacing={5} container>
            <Grid xs={12} item>
              <Box className="properties">
                <Typography className="property">Description</Typography>
                <Typography className="property-value">
                  {riskDetail.riskDescription}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={6} item>
              <Box className="properties">
                <Typography className="property">Risk Type</Typography>
                <Typography className="property-value">
                  {riskDetail.riskType}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={6} item>
              <Box className="properties">
                <Typography className="property">Risk Source</Typography>
                <Typography className="property-value">
                  {riskDetail.riskSource}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={6} item>
              <Box className="properties">
                <Typography className="property">Likelihood</Typography>
                <Typography className="property-value">
                  {riskDetail.likelihood}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={6} item>
              <Box className="properties">
                <Typography className="property">Impact</Typography>
                <Typography className="property-value">
                  {riskDetail.impact}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={6} item>
              <Box className="properties">
                <Typography className="property">
                  Affected Stakeholders
                </Typography>
                <Typography className="property-value">
                  {riskDetail.affectedStakeholders}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="app-card mt-5">
        <Box className="title">
          <Typography variant="h4">Mitigation</Typography>
        </Box>
        <Box className="content">
          <Grid spacing={5} container>
            <Grid xs={12} item>
              <Box className="properties">
                <Typography className="property">Status</Typography>
                <Typography className="property-value">
                  {riskDetail.mitigationStatus}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={12} item>
              <Box className="properties">
                <Typography className="property">Mitigation Plan</Typography>
                <Typography className="property-value">
                  {riskDetail.mitigationPlan}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="app-card mt-5">
        <Box className="title">
          <Typography variant="h4">Residual Risk</Typography>
        </Box>
        <Box className="content">
          <Grid spacing={5} container>
            <Grid xs={12} item>
              <Box className="properties">
                <Typography className="property">
                  Residual Risk Level
                </Typography>
                <Typography className="property-value">
                  {riskDetail.residualRiskLevel}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box className="app-card mt-5">
        <Box className="title">
          <Typography variant="h4">Framework Control Mappings</Typography>
        </Box>
        <Box className="content">
          <Grid spacing={5} container>
            <Grid xs={12} item>
              <Box className="properties">
                <Typography className="property">No controls mapped</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default DetailView;
